package top.wcpe.allincore.dsl.compiler.diag

/**
 * M5-f：源码片段，附加在 Diagnostic 上用于错误信息展示。
 *
 * @property filePath        源文件路径
 * @property lineNumber      错误所在行号（1-based）
 * @property columnNumber    错误所在列号（1-based）
 * @property contextLines    上下文若干行原文
 * @property errorLineIndex  错误行在 contextLines 中的索引（0-based）
 * @property markerStart     错误标记在错误行中的起始列（0-based）
 * @property markerLength    错误标记长度（最小为 1）
 */
data class SourceSnippet(
    val filePath: String,
    val lineNumber: Int,
    val columnNumber: Int,
    val contextLines: List<String>,
    val errorLineIndex: Int,
    val markerStart: Int,
    val markerLength: Int,
)
